import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../Home/Navbar";
import { CartProvider } from "react-use-cart";

const PageFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(saved);
  }, []);

  const memoizedFavorites = useMemo(() => {
    console.log("🔁 إعادة حساب المفضلة...");
    return favorites;
  }, [favorites]);

  const removeFromFavorites = (id) => {
    const updated = favorites.filter((item) => item.id !== id);
    setFavorites(updated);
    localStorage.setItem("favorites", JSON.stringify(updated));

    window.dispatchEvent(new Event("favoritesUpdated"));
  };

  if (!memoizedFavorites || memoizedFavorites.length === 0) {
    return (
      <div className="container text-center my-5">
        <p className="text-muted fs-5">
          <b>There are no products added yet💚</b>
        </p>
        <p className="text-secondary">
          <b>
            Start adding your favorite products from the products page to appear
            here!
          </b>
        </p>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4 text-success">Favorite Products💚</h2>
      <div className="row">
        {memoizedFavorites.map((product) => (
          <div key={product.id} className="col-md-4 mb-4">
            <div className="card  shadow-lg border-0">
              <img
                src={product.images[0]}
                className="card-img-top p-3"
                alt={product.name}
                style={{ height: "220px", objectFit: "contain" }}
              />
              <div className="card-body text-center">
                <h5 className="card-title mb-2">{product.name}</h5>
                <p className="card-text mb-3">
                  <b>${product.price}</b>
                </p>
                <button
                  className="btn btn-danger"
                  onClick={() => removeFromFavorites(product.id)}
                >
                  Remove form Favorites
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function Favorites() {
  return (
    <CartProvider>
      <Navbar />
      <br />
      <br />{" "}
      <div style={{ marginTop: "150px" }}>
        <PageFavorites />
      </div>
    </CartProvider>
  );
}

export default Favorites;
